import angular from "angular";
import toastr from "app/services/toastr";
import shajs from "app/services/sha";
import Constants from "app/services/Constants";
import ServiceRA from "app/services/ServiceRA";
import LocaleService from "app/services/LocaleService";
import Utils from "./Utils";
import AuthenticationService from "modules/dcb-eaccount/services/AuthenticationService";
import DownloadService from "./DownloadService";
import ConfigService from "app/services/ConfigService";
import FeatureService from "modules/dcb-eaccount/services/FeatureService";

export default angular.module("services.ContractService", [ServiceRA, toastr, shajs, LocaleService, Utils, AuthenticationService, DownloadService, ConfigService, FeatureService, Constants]).factory("ContractService", ["$http", "$q", "$log", "$state", "$rootScope", "toastr", "shajs", "ServiceRA", "Utils", "AuthenticationService", "DownloadService", "LocaleService", "ConfigService", "FeatureService", "Constants",
  function ContractService($http, $q, $log, $state, $rootScope, toastr, shajs, ServiceRA, Utils, AuthenticationService, DownloadService, LocaleService, ConfigService, FeatureService, Constants) {

    var abortGet = $q.defer();
    var filterFields = ["formattedName", "cardNr", "product.description"]; // INFO: if you change this, also change reference in CustomFilterService
    var CardMenu = [];
    var fieldsController;

    var basicAgreementFields = [
      {
        i18nKey: "common.columns.company",
        field: (item) => item.formattedName,
        sortField: "formattedName",
        defaultSorting: "asc",
        type: "text", // [text | number | money | date | custom]
        class: "col-xs-4",
        headerClass: "sort-align-right col-xs-4",
        slimtable: false,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "text", //[text | number | money | date ]
          field: "formattedName",
          shouldShow: (key, value) => true,
        }
      },
      {
        i18nKey: "common.columns.basicAgreementName",
        field: (item) => item.basicAgreementName,
        sortField: "basicAgreementName",
        type: "text", // [text | number | money | date | custom]
        class: "col-xs-4",
        headerClass: "sort-align-right col-xs-4",
        slimtable: true,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "text", //[text | number | money | date ]
          field: "basicAgreementName",
          shouldShow: (key, value) => true,
        }
      },
      {
        i18nKey: "common.columns.validUntil",
        field: (item) => _.get(item, "validUntil"),
        sortField: "validUntil",
        type: "date", // [text | number | money | date | custom]
        format: "shortDate",
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        slimtable: true,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true
      },
      {
        i18nKey: "common.columns.childContracts",
        field: (item) => item.childContracts.length,
        type: "number",
        format: "0",
        align: "right",
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        slimtable: true,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true
      },
      {
        i18nKey: "common.columns.printInvoice",
        field: (item) => "sendPrintedInvoiceValue",
        tooltipI18nKey: "contracts.tooltip.sendPrintedInvoice",
        type: "checkbox", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        slimtable: false,
        shouldShowColumn: (field) => false,
        shouldShow: (key, value) => false,
        shouldShowItem: (field, item) => false,
        onClick: (item) => activatePrintInvoice(item)
      },
      {
        i18nKey: "common.columns.emailNotification",
        field: (item) => "sendEmailNotificationValue",
        tooltipI18nKey: "contracts.tooltip.sendEmailNotification",
        type: "checkbox", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        slimtable: false,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        shouldShowItem: (field, item) => true,
        onClick: (item) => activateEmailNotification(item)
      },
      {
        i18nKey: "common.columns.emailAttachment",
        field: (item) => "sendEmailAttachmentValue",
        tooltipI18nKey: "contracts.tooltip.sendEmailAttachment",
        type: "checkbox", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        slimtable: false,
        shouldShowColumn: (field) => false,
        shouldShow: (key, value) => false,
        shouldShowItem: (field, item) => false,
        onClick: (item) => activateEmailAttachment(item)
      }
    ];

    var collapsedFields = [
      {
        column: 1,
        orderId: 1,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.previousBalance",
        value: "points.previousBalance"
      },
      {
        column: 1,
        orderId: 2,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.newCollected",
        value: "points.newCollected"
      },
      {
        column: 1,
        orderId: 3,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.bookings",
        value: "points.bookings"
      },
      {
        column: 1,
        orderId: 4,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.expired",
        value: "points.expired"
      },
      {
        column: 2,
        orderId: 1,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.articleEncashed",
        value: "points.articleEncashed"
      },
      {
        column: 2,
        orderId: 2,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.milesEncashed",
        value: "points.milesEncashed"
      },
      {
        column: 2,
        orderId: 3,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.currentBalance",
        value: "points.currentBalance"
      },
      {
        column: 2,
        orderId: 4,
        shouldShow: (key, value) => true,
        i18nKey: "list.details.points.nextOneExpiration",
        value: "points.nextOneExpiration"
      }
    ];

    var cardFields = [
      {
        i18nKey: "common.columns.cardnumber",
        aggregation: {
          i18nKey: "common.titles.totalSum"
        },
        field: (item) => _.get(item, "cardNr"),
        sortField: "cardNr",
        type: "text", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        headerToolTip: "common.columns.cardnumber",
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "text", //[text | number | money | date ]
          field: "cardNr",
          shouldShow: (key, value) => true,
        },
        clickableFeature: "cardList.allowClickDetails",
        onClick: (item) => fieldsController.gotoCard(item.id)
      },
      {
        i18nKey: "common.columns.validFrom",
        field: (item) => _.get(item, "displayValidFrom"),
        format: "shortDate",
        sortField: "displayValidFrom",
        type: "date", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "date", //[text | number | money | date ]
          field: "displayValidFrom",
          shouldShow: (key, value) => true
        }
      },
      {
        i18nKey: "common.columns.validUntil",
        field: (item) => _.get(item, "displayValidUntil"),
        format: "shortDate",
        sortField: "displayValidUntil",
        type: "date", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "date", //[text | number | money | date ]
          field: "displayValidUntil",
          shouldShow: (key, value) => true
        }
      },
      {
        i18nKey: "common.columns.nameOnCard",
        field: (item) => _.get(item, "formattedName"),
        sortField: "sortingName",
        type: "text", // [text | number | money | date | custom]
        class: "",
        headerClass: "sort-align-right",
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "text", //[text | number | money | date ]
          field: "formattedName",
          shouldShow: (key, value) => true,
        },
        clickableFeature: "cardList.allowClickDetails",
        onClick: (item) => fieldsController.gotoCard(item.id)
      },
      {
        i18nKey: "common.columns.cardType",
        field: (item) => _.get(item, "product.description"),
        sortField: "productTypeDescription",
        type: "text", // [text | number | money | date | custom]
        class: "col-xs-1",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        filter: {
          type: "text", //[text | number | money | date ]
          // type: "list"    /* to use a list as Filter, a pool has to be defined! See "pool" line how a pool should look like*/
          field: "product.description",
          // pool: [{"name":"Firmenkarte"},{"name":"Hauptkarte"}, {"name":"Zusatzkarte"}, {"name":"Zweitkarte"}],
          shouldShow: (key, value) => true,
        }
      },
      {
        i18nKey: "common.columns.spendingLimit",
        field: (item) => {
          if (_.get(item, "spendingLimit.das")) {
            return item.spendingLimit.das;
          } else {
            return null;
          }
        },
        sortField: "spendingLimit.das",
        type: "money",
        allowEmptyMoney: false,
        align: "right",
        class: "nowrap",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: () => FeatureService.hasFeatureInHash("cardList.showSpendingLimit"),
        shouldShow: (key, value) => true,
        filter: {
          type: "number", //[text | number | money | date ]
          field: "spendingLimit.das.value",
          placeholderI18nKey: "filter.placeholder.amount",
          rangeFilter: true,
          shouldShow: (key, value) => true,
        }
      },
      {
        i18nKey: "common.columns.transactionsCurrentYear",
        field: (item) => {
          if (_.get(item, "aggregatedData.transactionsThisYear")) {
            return item.aggregatedData.transactionsThisYear;
          } else {
            return null;
          }
        },
        sortField: "aggregatedData.transactionsThisYear",
        aggregation: {
          field: "aggr.['aggregatedData.transactionsThisYear']"
        },
        type: "money",
        allowEmptyMoney: false,
        align: "right",
        class: "nowrap",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: (field) => true,
        filter: {
          type: "number",
          field: "aggregatedData.transactionsThisYear.value",
          placeholderI18nKey: "filter.placeholder.amount",
          rangeFilter: true,
          shouldShow: (key, value) => true
        }
      },
      {
        i18nKey: "common.columns.transactions365",
        field: (item) => {
          if (_.get(item, "aggregatedData.transactions365")) {
            return item.aggregatedData.transactions365;
          } else {
            return null;
          }
        },
        sortField: "aggregatedData.transactions365",
        aggregation: {
          field: "aggr.['aggregatedData.transactions365']"
        },
        type: "money",
        allowEmptyMoney: false,
        align: "right",
        class: "nowrap",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: (field) => true,
        filter: {
          type: "number",
          field: "aggregatedData.transactions365.value",
          placeholderI18nKey: "filter.placeholder.amount",
          rangeFilter: true,
          shouldShow: (key, value) => true
        }
      },
      {
        i18nKey: "common.columns.loungeVisits",
        field: (item) => {
          if (_.get(item, "aggregatedData.loungeVisits")) {
            return item.aggregatedData.loungeVisits;
          } else {
            return 0;
          }
        },
        sortField: "aggregatedData.loungeVisits",
        aggregation: {
          field: "aggr.['aggregatedData.loungeVisits']"
        },
        type: "number",
        format: "0",
        align: "right",
        class: "nowrap",
        headerClass: "sort-align-right col-xs-1",
        notificationlist: false,
        shouldShowColumn: (field) => true,
        filter: {
          type: "number",
          field: "aggregatedData.loungeVisits",
          placeholderI18nKey: "filter.placeholder.amount",
          rangeFilter: true,
          shouldShow: (key, value) => true
        }
      },
      {
        i18nKey: "common.columns.printInvoice",
        field: (item) => "sendPrintedInvoiceValue",
        tooltipI18nKey: "contracts.tooltip.sendPrintedInvoice",
        type: "checkbox", // [text | number | money | date | custom]
        class: "col-xs-2",
        headerClass: "sort-align-right col-xs-2",
        notificationlist: true,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        shouldShowItem: (field, item) => true,
        onClick: (item) => activatePrintInvoice(item)
      },
      {
        i18nKey: "common.columns.emailNotification",
        field: (item) => "sendEmailNotificationValue",
        tooltipI18nKey: "contracts.tooltip.sendEmailNotification",
        type: "checkbox", // [text | number | money | date | custom]
        class: "col-xs-2",
        headerClass: "sort-align-right col-xs-2",
        notificationlist: true,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        shouldShowItem: (field, item) => true,
        onClick: (item) => activateEmailNotification(item)
      },
      {
        i18nKey: "common.columns.emailAttachment",
        field: (item) => "sendEmailAttachmentValue",
        tooltipI18nKey: "contracts.tooltip.sendEmailAttachment",
        type: "checkbox", // [text | number | money | date | custom]
        class: "col-xs-2",
        headerClass: "sort-align-right col-xs-2",
        notificationlist: true,
        shouldShowColumn: (field) => true,
        shouldShow: (key, value) => true,
        shouldShowItem: (field, item) => true,
        onClick: (item) => activateEmailAttachment(item)
      },
      {
        type: "checkboxes",
        tooltipI18nKey: "contracts.tooltip.check",
        style: { width: "1%" },
        notificationlist: false,
        shouldShowColumn: (field) => true
      }
    ];

    function findAgreements(search, searchFields, max) {

      if (abortGet) {
        abortGet.promise.isGloballyCanceled = true;
        abortGet.resolve();
      }
      abortGet = $q.defer();

      var query = {
        "$q": search,
        "$qf": searchFields,
        "max": max || "$max",
        "type": "BA",
        "id": AuthenticationService.getSelectedContract()
      };

      return ServiceRA.all("contracts").withHttpConfig({
        timeout: abortGet.promise
      }).getList(query);

    }

    function getContracts(search, searchFields) {

      var defer = $q.defer();

      if (search && searchFields) {

        var query = {
          "$q": search,
          "$qf": searchFields,
          "max": "$max",
          "id": AuthenticationService.getSelectedContract()
        };

        /* This Function is not used! If used, issuer should be included:
         var includedIssuers = ConfigService.get("includedIssuers.contracts", true);
         if (includedIssuers) {
         qo.filter.issuer = includedIssuers;
         }
         */

        ServiceRA.all("contracts").getList(query).then(function (result) {
          defer.resolve(result.data);
        }, defer.reject);

      }
      else {

        $http.get(ConfigService.get("urls.dcb-ea-customer", true) + "/contracts?max=$max").success(function (response) {
          defer.resolve(response.data);
        }).error(defer.reject);
      }

      return defer.promise;


    }

    function getContract(id) {
      var defer = $q.defer();

      ServiceRA.one("contracts", id).get().then(function (response) {
        defer.resolve(response);
      }, function (err) {
        Utils.handleError(err);
        defer.reject(err);
      });
      return defer.promise;
    }

    function changeContract(contractId, contract, deliveryType) {
      var defer = $q.defer();

      contract[deliveryType].value = !contract[deliveryType].value;
      if (contract.sendPrintedInvoice.value || contract.sendEmailAttachment.value || contract.sendEmailNotification.value) {

        if (contract.sendEmailNotification.value && contract.sendEmailAttachment.value) {
          contract.sendEmailNotification.value = false;
          contract.sendEmailAttachment.value = false;
          contract[deliveryType].value = true;
        }

        var postData = {
          sendEmailNotification: _.get(contract, "sendEmailNotification.value"),
          sendEmailAttachment: _.get(contract, "sendEmailAttachment.value"),
          sendPrintedInvoice: _.get(contract, "sendPrintedInvoice.value")
        };

        ServiceRA.one("contracts", contractId).customPUT(postData).then(function (response) {
          toastr.success(LocaleService.get("cardPage.notifications.changeInvoice"));
          defer.resolve(response);
        }, function (err) {
          toastr.error(LocaleService.get("cardPage.error.changeDeliverytype"));
          $log.error(err);
          defer.reject(err);
        });
      } else {
        contract[deliveryType].value = !contract[deliveryType].value;
        toastr.error(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
        defer.reject();
      }

      return defer.promise;
    }

    function changeSSMS(number, state, isactive, contractId, numberChanged) {
      var defer = $q.defer();

      if (!isactive && !number) {
        toastr.error(LocaleService.get("cardPage.error.changeSSMS"));
        defer.reject();
      } else {
        AuthenticationService.getUser().then((user) => {
          var useId = user._id;
          var actionToDo = "";

          if (isactive && !numberChanged) {
            actionToDo = "disableSecureSms";
          } else {
            actionToDo = "enableSecureSms";
          }

          ServiceRA.one("contracts", contractId).one("phoneNumbers", number).one(actionToDo).customPOST().then(function (response) {
            toastr.success(LocaleService.get("cardPage.notifications.changeSSMS"));
            defer.resolve(response);
          }, function (err) {
            Utils.handleError(err, LocaleService.get("cardPage.error.changeSSMS"));
            defer.reject(err);
          });
        });
      }

      return defer.promise;
    }

    function getSSMSMessenger(phoneNumber) {
      var defer = $q.defer();

      AuthenticationService.getUser().then((user) => {
        var useId = _.get(user, "actingAsUser._id") || _.get(user, "_id");
        ServiceRA.one("users", useId).one("phoneNumbers", phoneNumber).one("settings").get().then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err);
          defer.reject(err);
        });
      });

      return defer.promise;
    }

    function getPhoneNumbers() {
      var defer = $q.defer();

      AuthenticationService.getUser().then((user) => {
        var useId = _.get(user, "actingAsUser._id") || _.get(user, "_id");
        ServiceRA.one("users", useId).one("phoneNumbers").get().then(function (response) {
          defer.resolve(response);
        }, function (err) {
          Utils.handleError(err);
          defer.reject(err);
        });
      });

      return defer.promise;
    }

    function getVerifiedPhoneNumbers() {
      var defer = $q.defer();

      AuthenticationService.getUser().then((user) => {
        var useId = _.get(user, "actingAsUser._id") || _.get(user, "_id");
        ServiceRA.one("users", useId).one("phoneNumbers").get({}).then(function (response) {
          if (response && response.data) {
            defer.resolve(response.data.filter((elem) => {
              return ["user.profile.phoneNumber.status.verified", "user.profile.phoneNumber.status.inUse"].indexOf(elem.status) > -1;
            }));
          }
          else {
            defer.resolve([]);
          }
        }, function (err) {
          Utils.handleError(err);
          defer.reject(err);
        });
      });

      return defer.promise;
    }

    function getCurrentProtectBuyNumber(verifiedNumbers) {
      let curPhone = verifiedNumbers.filter((item) => _.get(item, "hasProtectBuy") || _.get(item, "hasProtectBuy2FA"))[0];
      return _.get(curPhone, "id");  // if User has no phone => [0] is undefined => id of undefined = error => use lodash!
    }

    function sendPINChangeRequest(contract, newPIN) {
      var defer = $q.defer();
      //console.log("CLIENT=", ConfigService.getClient());

      ServiceRA.one("contracts", contract.id).one("changePin").customPOST({
        pin: newPIN
      }).then(function (response) {
        toastr.success(LocaleService.get("changePin.card.ok"));
        defer.resolve(response);
      }, function (err) {
        Utils.handleError(err, LocaleService.get("changePin.card.error"));
        defer.reject(err);
      });

      return defer.promise;
    }

    function sendLockCardRequest(contract, user) {
      var defer = $q.defer();
      var messageTitle = LocaleService.get("lockCard.sendmail.title", { "email": user.email, "customerId": user.customerId, "franchise": ConfigService.getClient() });
      var messageText = LocaleService.get("lockCard.sendmail.text", { "email": user.email, "customerId": user.customerId, "cardId": contract.id, "customerIdContract": contract.customerId });
      var sender = AuthenticationService.getUserWithoutReload().email;
      var localeLang = LocaleService.getCurrentLocale().substring(0, 2);

      ServiceRA.one("emails").customPOST({
        from: sender,
        // to: recipient,
        template: "customemail",
        language: localeLang,
        data: {
          customSubject: messageTitle,
          customText: messageText,
          customType: Constants.LOCK_CARD_REQUEST_IDENTIFIER
        }
      }, null, { /*conId: contract.id*/ }).then(function (response) {
        toastr.success(LocaleService.get("lock.card.ok"));
        defer.resolve(response);
      }, function (err) {
        Utils.handleError(err, LocaleService.get("lock.card.error"));
        defer.reject(err);
      });

      return defer.promise;
    }

    function sendCancelCardRequest() {
      return window.open(ConfigService.get("links.changeRequestPDF", true));
    }

    function sendAdditionSettingWrapper(ccsid, setting) {
      return getContract(ccsid).then((contract) => {
        AuthenticationService.getUser().then((user) => {
          sendAdditionSettingRequest(contract, setting, user);
        });
      });
    }

    function sendAdditionSettingRequest(contract, setting, user) {
      var defer = $q.defer();
      var messageTitle = LocaleService.get("additionalSetting.sendmail.title", { "email": user.email, "customerId": user.customerId, "franchise": ConfigService.getClient() });
      var messageText = LocaleService.get("additionalSetting.sendmail.text", { "email": user.email, "customerId": user.customerId, "cardId": contract.id, "customerIdContract": contract.customerId, "setting": setting });

      // var recipient = ConfigService.get("links.serviceEMail", true) || ConfigService.get("links.contactEMail", true);
      var sender = AuthenticationService.getUserWithoutReload().email;
      var localeLang = LocaleService.getCurrentLocale().substring(0, 2);

      ServiceRA.one("emails").customPOST({
        from: sender,
        // to: recipient,
        template: "customemail",
        language: localeLang,
        data: {
          customSubject: messageTitle,
          customText: messageText,
          customType: Constants.ADDITIONAL_SETTING_REQUEST_IDENTIFIER
        }
      }, null, null).then(function (response) {
        toastr.success(LocaleService.get(setting + ".sendmail.ok"));
        defer.resolve(response);
      }, function (err) {
        Utils.handleError(err, LocaleService.get(setting + ".sendmail.error"));
        defer.reject(err);
      });

      return defer.promise;
    }

    function getUsersForContract(contractId) {
      var defer = $q.defer();

      ServiceRA.one("contracts", contractId).one("users").get().then(function (response) {
        defer.resolve(response.data);
      }, function (err) {
        Utils.handleError(err);
        defer.reject(err);
      });
      return defer.promise;
    }

    function removeUserFromCard(contractId) {
      var defer = $q.defer();
      //var useId = AuthenticationService.getUser().id;

      AuthenticationService.getUser().then((user) => {
        var useId = user._id;
        ServiceRA.one("contracts", contractId).one("users", useId).one("write").remove().then(function (response) {
          defer.resolve(response.data);
        }, function (err) {
          Utils.handleError(err);
          defer.reject(err);
        });
      });

      return defer.promise;
    }

    function getBasicAgreements(parentCompanyIds, directCompanyIds) {
      var defer = $q.defer();

      if ((parentCompanyIds && parentCompanyIds.length > 0) || (directCompanyIds && directCompanyIds.length > 0)) {
        var url = ConfigService.get("urls.dcb-ea-customer", true) + "/contracts?type=BA&max=$max";
        for (var i = 0; i < directCompanyIds.length; i++) {
          url += "&parentCompany=" + directCompanyIds[i];
        }

        for (var j = 0; j < parentCompanyIds.length; j++) {
          url += "&companyPath=," + parentCompanyIds[j] + "*";
        }

        $http.get(url).success(function (response) {
          defer.resolve(response.data);
        }).error(defer.reject);
      }
      else {
        defer.resolve([]);
      }

      return defer.promise;
    }


    var regexpFields = filterFields;
    var dateFields = ["displayValidFrom", "displayValidUntil"];
    
    var TYPE = "contracts";

    function getCards(_qo, overwrittenIncludedIssuers, ignoreTimeout, ignoreContractFilter, ccsId) {
      if (!ignoreTimeout) {
        if (abortGet) {
          abortGet.promise.isGloballyCanceled = true;
          abortGet.resolve();
        }
        abortGet = $q.defer();
      }

      var qo = _qo || {
        filter: {}
      };

      var includedIssuers = ConfigService.get(overwrittenIncludedIssuers || "includedIssuers.cards", true);
      if (includedIssuers) {
        qo.filter.issuer = includedIssuers;
      }

      qo.filter.type = "Card";

      var regexpFields = ["formattedName", "cardNr", "product.description"];
      var dateFields = ["displayValidFrom", "displayValidUntil"];

      qo = Utils.prepareFilter(qo, regexpFields, dateFields);
      qo.filter.aggr = ["aggregatedData.loungeVisits", "aggregatedData.transactions365", "aggregatedData.transactionsThisYear"];

      if (ignoreContractFilter) {

      }
      else {
        qo.filter.id = AuthenticationService.getSelectedContract() || ccsId;
      }


      if (FeatureService.hasFeatureInHash("dashboard.layout.cardbased")) {
        qo.filter.sortByProductType = true;
      }

      var headers = Utils.prepareHeaders("getContracts");

      var timeoutBody = {};

      if (!ignoreTimeout) {
        timeoutBody = {
          timeout: abortGet.promise
        };
      }

      if (!FeatureService.hasFeatureInHash("list.aggregate")) {
        delete qo.filter.aggr;
      }

      return ServiceRA.all("contracts").withHttpConfig(timeoutBody).getList(qo.filter, headers);
    }

    function getAllCustomerCards(_qo) {
      var qo = _qo;

      var includedIssuers = ConfigService.get("includedIssuers.cards", true);
      if (includedIssuers) {
        qo.filter.issuer = includedIssuers;
      }

      // ToDo: Maybe this should be flexible; at the moment only valid cards are needed...
      qo.filter.validOnly = true;

      qo = Utils.prepareFilter(qo);

      var headers = Utils.prepareHeaders("getAllContracts");
      var timeoutBody = {};

      if (!FeatureService.hasFeatureInHash("list.aggregate")) {
        delete qo.filter.aggr;
      }

      return ServiceRA.all("contracts").all("allCustomerCards").withHttpConfig(timeoutBody).getList(qo.filter, headers);
    }

    function getBAs(_qo, overwrittenIncludedIssuers) {

      if (abortGet) {
        abortGet.promise.isGloballyCanceled = true;
        abortGet.resolve();
      }
      abortGet = $q.defer();

      var qo = _qo || {
        filter: {}
      };

      var includedIssuers = ConfigService.get(overwrittenIncludedIssuers || "includedIssuers.contracts", true);
      if (includedIssuers) {
        qo.filter.issuer = includedIssuers;
      }

      qo.filter.type = "BA";

      var regexpFields = ["formattedName", "basicAgreementName", "product.description"];
      var dateFields = [];

      qo = Utils.prepareFilter(qo, regexpFields, dateFields);
      qo.filter.aggr = [];

      var headers = Utils.prepareHeaders("getContracts");

      return ServiceRA.all("contracts").withHttpConfig({
        timeout: abortGet.promise
      }).getList(qo.filter, headers);
    }

    function exportCards(filter, exportType, fields, filename, sortingFields) {

      filter.max = ConfigService.get(TYPE + ".maxDownloadCount", true) || "$max"; // 1000;
      filter.id = AuthenticationService.getSelectedContract();
      //filter.fields = fields || EXPORT_FIELDS;
      //fields = fields || EXPORT_FIELDS;
      filter.type = "Card";

      var qs = Utils.getQueryString(Utils.prepareFilter(filter, regexpFields, dateFields, sortingFields));
      var url = ConfigService.get("urls.dcb-ea-customer", true) + "/" + TYPE; // ServiceRA.all(TYPE).getRestangularUrl();

      var query = Utils.getQuery(url, qs);

      DownloadService.exportQuery(query, exportType, fields, filename, "downloadContracts");
    }

    function getBasicAgreementFields(slimtable) {
      if (slimtable) {
        return angular.copy(basicAgreementFields.filter(function (elem) {
          return elem.slimtable === true;
        }));

      }
      else {
        return angular.copy(basicAgreementFields);
      }
    }

    function getCardFields(notificationlist, ctrl) {

      if (ctrl) {
        fieldsController = ctrl;
      }

      if (notificationlist) {
        return angular.copy(cardFields.filter(function (elem) {
          return elem.notificationlist !== false; // true or undefined
        }));
      }
      else {
        return angular.copy(cardFields.filter(function (elem) {
          return elem.notificationlist !== true; // false or undefined
        }));
      }
    }

    function activatePrintInvoice(contract) {
      if (contract.sendEmailAttachmentValue || contract.sendEmailNotificationValue || !contract.sendPrintedInvoiceValue) {
        contract.sendPrintedInvoiceValue = !contract.sendPrintedInvoiceValue;

        ServiceRA.one("contracts", contract.id).customPUT({
          sendPrintedInvoice: contract.sendPrintedInvoiceValue
        }).then(function (response) {
          toastr.success(LocaleService.get("cardPage.notifications.changeInvoice"));
          $q.defer().resolve(response);
        }, function (err) {
          toastr.success(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
          $log.error(err);
          $q.defer().reject(err);
        });
      } else {
        toastr.error(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
      }
    }

    function activateEmailNotification(contract) {
      if (contract.sendEmailAttachmentValue || !contract.sendEmailNotificationValue || contract.sendPrintedInvoiceValue) {
        contract.sendEmailNotificationValue = !contract.sendEmailNotificationValue;

        ServiceRA.one("contracts", contract.id).customPUT({
          sendEmailNotification: contract.sendEmailNotificationValue
        }).then(function (response) {
          toastr.success(LocaleService.get("cardPage.notifications.changeInvoice"));
          $q.defer().resolve(response);
        }, function (err) {
          toastr.success(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
          $log.error(err);
          $q.defer().reject(err);
        });
      } else {
        toastr.error(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
      }
    }

    function activateEmailAttachment(contract) {
      if (!contract.sendEmailAttachmentValue || contract.sendEmailNotificationValue || contract.sendPrintedInvoiceValue) {
        contract.sendEmailAttachmentValue = !contract.sendEmailAttachmentValue;

        ServiceRA.one("contracts", contract.id).customPUT({
          sendEmailAttachment: contract.sendEmailAttachmentValue
        }).then(function (response) {
          toastr.success(LocaleService.get("cardPage.notifications.changeInvoice"));
          $q.defer().resolve(response);
        }, function (err) {
          toastr.success(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
          $log.error(err);
          $q.defer().reject(err);
        });
      } else {
        toastr.error(LocaleService.get("cardPage.notifications.errorchangeInvoice"));
      }
    }

    function getStateParamMapping() {
      return {
        "cardNr": "text",
        "basicAgreementName": "text",
        "displayValidFrom": "date",
        "displayValidUntil": "date",
        "aggregatedData.transactionsThisYear.valueFrom": "number",
        "aggregatedData.transactionsThisYear.valueUntil": "number",
        "aggregatedData.transactions365.valueFrom": "number",
        "aggregatedData.transactions365.valueUntil": "number",
        "aggregatedData.loungeVisitsFrom": "number",
        "aggregatedData.loungeVisitsUntil": "number",
        "product.description": "text",
        "downloadError": "ignore",
      };
    }

    function getRegexpFields() {
      return regexpFields;
    }

    function getDateFields() {
      return dateFields;
    }

    function getFilterFields() {
      return filterFields;
    }

    function getCollapsedFields(dashboard) {
      return angular.copy(collapsedFields);
    }

    function addCardToUser(card) {
      var defer = $q.defer();
      var headers = Utils.prepareHeaders("addCard");

      ServiceRA.one("contracts").one("users").customPOST({
        cardNr: shajs("sha256").update(card.cardNr).digest("hex"),
        cvv2: card.cvv2,
        birthday: Utils.getDateField(card.birthday)
      }, null, null, headers).then(function (response) {

        defer.resolve(response);
      }, function (err) {
        $log.error(err);
        defer.reject(err);
      });

      return defer.promise;
    }

    function addUserToContract(user, contract, type) {
      var defer = $q.defer();
      var headers = Utils.prepareHeaders();

      ServiceRA.one("contracts/" + contract.id + "/users/" + user._id).customPUT({
      }, null, { type: type }, headers).then(function (response) {
        defer.resolve(response);
      }, function (err) {
        $log.error(err);
        defer.reject(err);
      });

      return defer.promise;

    }

    function removeUserFromContract(user, contract, type) {
      var defer = $q.defer();
      var headers = Utils.prepareHeaders();

      //console.log("typeof type=", typeof type);
      //console.log("type=", type);

      ServiceRA.one("contracts/" + contract.id + "/users/" + user._id + "/" + type).customDELETE(null, headers).then(function (response) {
        defer.resolve(response);
      }, function (err) {
        $log.error(err);
        defer.reject(err);
      });

      return defer.promise;

    }

    return {
      getContracts: getContracts,
      getBasicAgreements: getBasicAgreements,
      getCards: getCards,
      getAllCustomerCards: getAllCustomerCards,
      getBAs: getBAs,
      exportCards: exportCards,
      findAgreements: findAgreements,
      getContract: getContract,
      changeContract: changeContract,
      changeSSMS: changeSSMS,
      getSSMSMessenger: getSSMSMessenger,
      getPhoneNumbers: getPhoneNumbers,
      getVerifiedPhoneNumbers: getVerifiedPhoneNumbers,
      getCurrentProtectBuyNumber: getCurrentProtectBuyNumber,
      sendPINChangeRequest: sendPINChangeRequest,
      sendLockCardRequest: sendLockCardRequest,
      sendCancelCardRequest: sendCancelCardRequest,
      sendAdditionSettingWrapper: sendAdditionSettingWrapper,
      sendAdditionSettingRequest: sendAdditionSettingRequest,
      getUsersForContract: getUsersForContract,
      removeUserFromCard: removeUserFromCard,
      activateEmailNotification: activateEmailNotification,
      getBasicAgreementFields: getBasicAgreementFields,
      getCardFields: getCardFields,
      getStateParamMapping: getStateParamMapping,
      getRegexpFields: getRegexpFields,
      getDateFields: getDateFields,
      getFilterFields: getFilterFields,
      getCollapsedFields: getCollapsedFields,
      addCardToUser: addCardToUser,
      addUserToContract: addUserToContract,
      removeUserFromContract: removeUserFromContract

    };
  }]).name;


// WEBPACK FOOTER //
// ./src/ui/modules/dcb-eaccount/services/ContractService.js